import Api from './api';

export default {
  sendMessage: (data) => Api.post('contact', data),
};
